
import React from "react";
import { connect } from "react-redux";
import "react-table/react-table.css";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";

import LocalizedStrings from "react-localization";
import { localisedText } from "../../lib/localisation.es6";
import { getPartner } from "../../lib/access.es6";
import { updateCurrentLanguage } from "../../lib/languageUtils.es6";
import * as actions from "./actions.es6";
import SkeletonWrapper from "../../components/SkeletonWrapper/SkeletonWrapper";
import AlertDialog from "../../components/AlertDialog/index.es6";

import UpdatePartner from "./components/Edit/UpdatePartner";
import UpdatePartnerConfig from "./components/Edit/UpdatePartnerConfig";
import UpdatePartnerConfigClaim from "./components/Edit/UpdatePartnerConfigClaim";
import UpdatePartnerConfigEmail from "./components/Edit/UpdatePartnerConfigEmail";
import AddEditSmsChannel from "./components/Edit/AddEditSmsChannel";
import TestSmsChannelDialog from "./components/Edit/TestSmsChannelDialog";
import EditChannelResolution from "./components/Edit/EditChannelResolution";
import AddEditPolicyMakerCheck from "./components/Edit/AddEditPolicyMakerCheck";

import ViewPartner from "./components/view/ViewPartner";
import ViewPartnerConfig from "./components/view/ViewPartnerConfig";
import ViewPartnerConfigClaim from "./components/view/ViewPartnerConfigClaim";
import ViewPartnerEmailConfig from "./components/view/ViewPartnerEmailConfig";
import ViewPartnerSmsConfig from "./components/view/ViewPartnerSmsConfig";
import ViewPolicyMakerChecks from "./components/view/ViewPolicyMakerChecks";

export class PartnerStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      labels: new LocalizedStrings(localisedText),
      openUpdatePartnerDialog: false,
      openUpdatePartnerConfigDialog: false,
      openUpdatePartnerConfigEmailDialog: false,
      openUpdatePartnerConfigClaimDialog: false,
      openUpdatePartnerConfigGroupDialog: false,
      openAddSmsChannelDialog: false,
      openChannelResolutionDialog: false,
      editSmsChannel: null,
      testSmsChannel: null,
      openPolicyMakerCheckDialog: false,
      editPolicyMakerCheck: null,
      // Shared in-app confirm for destructive actions (replaces window.confirm).
      // Holds { title, onConfirm } for the pending delete, or null when closed.
      pendingDelete: null,
    };
  }

  componentWillMount() {
    this.updateLanguage();
    this.props.dispatch(actions.getPartnerConfigsRequest())
    this.props.dispatch(actions.getPartnerEmailConfigsRequest())
    this.props.dispatch(actions.getPartnerConfigsClaimRequest())
    this.props.dispatch(actions.getPartnerConfigsGroupRequest())
    this.props.dispatch(actions.getEmailClientsRequest())
    this.props.dispatch(actions.getPartnerSmsChannelsRequest())
    this.props.dispatch(actions.getPolicyMakerChecksRequest())
  }

  componentDidUpdate() {
    this.updateLanguage();
  }

  updateLanguage() {
    updateCurrentLanguage(
      this.props.globalData.language,
      "PartnerStatus",
      this.state.labels
    );
  }

  updatePartner(partner) {
    this.props.dispatch(actions.updatePartnerRequest(partner));
  }

  updatePartnerConfig(partnerConfig) {
    this.props.dispatch(actions.updatePartnerConfigRequest(partnerConfig));
  }

  updatePartnerConfigClaim(partnerConfigClaim) {
    this.props.dispatch(actions.updatePartnerConfigClaimRequest(partnerConfigClaim));
  }

  updatePartnerConfigEmail(partnerConfigEmail) {
    this.props.dispatch(actions.updatePartnerConfigEmailRequest(partnerConfigEmail));
  }

  saveSmsChannel(channel) {
    this.props.dispatch(actions.saveSmsChannelRequest(channel));
  }

  deleteSmsChannel(channelName) {
    this.props.dispatch(actions.deleteSmsChannelRequest(channelName));
  }

  testSmsChannel(payload) {
    this.props.dispatch(actions.testSmsChannelRequest(payload));
  }

  updatePartnerConfigGroup(partnerConfigGroup) {
    this.props.dispatch(actions.updatePartnerConfigGroupRequest(partnerConfigGroup));
  }


  resetUpdatePartnerSuccessAlert = () => {
    this.props.dispatch(actions.resetUpdatePartnerSuccess())
  }

  resetUpdatePartnerConfigSuccessAlert = () => {
    this.props.dispatch(actions.resetUpdatePartnerConfigSuccess())
    this.props.dispatch(actions.getPartnerConfigsRequest())
  }

  resetUpdatePartnerConfigClaimSuccessAlert = () => {
    this.props.dispatch(actions.resetUpdatePartnerConfigClaiimSuccess())
    this.props.dispatch(actions.getPartnerConfigsClaimRequest())
  }

  resetUpdatePartnerConfigEmailSuccessAlert = () => {
    this.props.dispatch(actions.resetUpdatePartnerConfigEmailSuccess())
    this.props.dispatch(actions.getPartnerEmailConfigsRequest())
  }

  resetSaveSmsChannelSuccessAlert = () => {
    this.props.dispatch(actions.resetSaveSmsChannelSuccess())
  }

  resetDeleteSmsChannelSuccessAlert = () => {
    this.props.dispatch(actions.resetDeleteSmsChannelSuccess())
  }

  saveChannelResolution(payload) {
    this.props.dispatch(actions.saveChannelResolutionRequest(payload));
  }

  savePolicyMakerCheck(check) {
    this.props.dispatch(actions.savePolicyMakerCheckRequest(check));
  }

  deletePolicyMakerCheck(guid) {
    this.props.dispatch(actions.deletePolicyMakerCheckRequest(guid));
  }

  resetSavePolicyMakerCheckSuccessAlert = () => {
    this.props.dispatch(actions.resetSavePolicyMakerCheckSuccess())
    this.setState({ openPolicyMakerCheckDialog: false, editPolicyMakerCheck: null })
  }

  resetUpdatePartnerConfigGroupSuccessAlert = () => {
    this.props.dispatch(actions.resetUpdatePartnerConfigGroupSuccess())
    this.props.dispatch(actions.getPartnerConfigsGroupRequest())
  }

  sanitizeList(listString) {
    if (!listString) {
      return
    }
    if (Array.isArray(listString)) {
      return listString.filter(x => x !== "");
    }
    let formatedList = listString.replaceAll("[", "").replaceAll("]", "").replaceAll(" ", "").split(",")
    return formatedList.filter(i => i.length > 0)
  }

  convertStringToList(listString) {
    if (!listString) {
      return [];
    }
    return listString.split(',').map(x => x.trim());
  }

  removeSquareBrackets(listString) {
    if (!listString) {
      return ""
    }
    if (Array.isArray(listString)) {
      return listString.join(",");
    }
    return listString.replaceAll("[", "").replaceAll("]", "")
  }

  render() {
    const partnerConfigEmailClients = this.props.partnerStatusData.partnerConfigEmailClients;
    const partner = getPartner();

    const partnerConfig = this.props.partnerStatusData.partnerConfig;
    const partnerConfigEmail = this.props.partnerStatusData.partnerConfigEmail;
    const partnerConfigClaim = this.props.partnerStatusData.partnerConfigClaim;
    const smsChannels = this.props.partnerStatusData.smsChannels || [];
    const smsChannelResolution = this.props.partnerStatusData.smsChannelResolution;


    console.log();
    return (
      <React.Fragment>
        <CssBaseline />
        <Container maxWidth="lg" style={{ marginTop: "2%" }}>
          <SkeletonWrapper loading={this.props.partnerStatusData.updatePartnerConfigLoader} />
          <ViewPartner
            partner={partner}
            partnerConfig={partnerConfig}
            isLoading={this.props.partnerStatusData.updatePartnerLoader}
            openUpdatePartnerDialog={() => { this.setState({ openUpdatePartnerDialog: true }) }}
          />

          <ViewPartnerConfig
            partner={partner}
            partnerConfig={partnerConfig}
            isLoading={this.props.partnerStatusData.partnerConfigLoader}
            openUpdatePartnerConfigDialog={() => { this.setState({ openUpdatePartnerConfigDialog: true }) }}
            formatAndConvertToListString={this.sanitizeList.bind(this)}
          />


          <ViewPartnerEmailConfig
            partnerConfigEmail={partnerConfigEmail}
            partnerConfigEmailClients={partnerConfigEmailClients}
            isLoading={this.props.partnerStatusData.partnerEmailConfigLoader}
            openUpdatePartnerConfigEmailDialog={() => { this.setState({ openUpdatePartnerConfigEmailDialog: true }) }}
            formatAndConvertToListString={this.sanitizeList.bind(this)}
          />

          <ViewPartnerConfigClaim
            partnerConfigClaim={partnerConfigClaim}
            isLoading={this.props.partnerStatusData.partnerConfigClaimLoader}
            openUpdatePartnerConfigClaimDialog={() => { this.setState({ openUpdatePartnerConfigClaimDialog: true }) }}
            formatAndConvertToListString={this.sanitizeList.bind(this)}
          />

          <ViewPartnerSmsConfig
            smsChannels={smsChannels}
            smsChannelResolution={smsChannelResolution}
            isLoading={this.props.partnerStatusData.smsChannelsLoader}
            onAddChannel={() => {
              this.setState({ openAddSmsChannelDialog: true, editSmsChannel: null })
            }}
            onEditChannel={(channel) => {
              this.setState({ openAddSmsChannelDialog: true, editSmsChannel: channel })
            }}
            onDeleteChannel={(channel) => {
              this.setState({
                pendingDelete: {
                  title: 'Delete channel "' + (channel.channel_name || '(default)') + '"? This cannot be undone.',
                  onConfirm: () => this.deleteSmsChannel(channel.channel_name || '_default')
                }
              })
            }}
            onTestChannel={(channel) => {
              this.setState({ testSmsChannel: channel })
            }}
            onConfigureResolution={() => {
              this.setState({ openChannelResolutionDialog: true })
            }}
          />

          <ViewPolicyMakerChecks
            policyMakerChecks={this.props.partnerStatusData.policyMakerChecks || []}
            isLoading={this.props.partnerStatusData.policyMakerChecksLoader}
            onAddCheck={() => {
              this.setState({ openPolicyMakerCheckDialog: true, editPolicyMakerCheck: null })
            }}
            onEditCheck={(check) => {
              this.setState({ openPolicyMakerCheckDialog: true, editPolicyMakerCheck: check })
            }}
            onDeleteCheck={(check) => {
              this.setState({
                pendingDelete: {
                  title: 'Delete check "' + (check.label || '') + '"? This cannot be undone.',
                  onConfirm: () => this.deletePolicyMakerCheck(check.guid)
                }
              })
            }}
          />

          <AlertDialog
            warning
            show={!!this.state.pendingDelete}
            size="sm"
            title={this.state.pendingDelete ? this.state.pendingDelete.title : ''}
            style={{ marginTop: '0', top: '30vh' }}
            onConfirm={() => { this.setState({ pendingDelete: null }) }}
            onCancel={() => {
              const pending = this.state.pendingDelete
              this.setState({ pendingDelete: null })
              if (pending) { pending.onConfirm() }
            }}
            confirmBtnText={'Cancel'}
            showCancel={true}
            showConfirm={true}
            cancelBtnText={'Delete'}
            confirmBtnCssClass
          />

          <UpdatePartner
            showUpdatePartnerDialog={this.state.openUpdatePartnerDialog}
            closeUpdatePartnerDialog={() => { this.setState({ openUpdatePartnerDialog: false }) }}
            partner={partner}
            showUpdatePartnerProgressAlert={this.props.partnerStatusData.updatePartnerLoader}
            showUpdatePartnerSuccessAlert={this.props.partnerStatusData.updatePartnerSuccess}
            showUpdatePartnerErrorAlert={!!this.props.partnerStatusData.updatePartnerError}
            updatePartnerError={this.props.partnerStatusData.updatePartnerError}
            updatePartner={this.updatePartner.bind(this)}

            resetUpdatePartnerSuccessAlert={this.resetUpdatePartnerSuccessAlert.bind(this)}
            resetUpdatePartnerErrorAlert={() => { this.props.dispatch(actions.resetUpdatePartnerError()) }}

            formatAndConvertToListString={this.sanitizeList.bind(this)}
            removeSquareBrackets={this.removeSquareBrackets.bind(this)}
            convertListToString={this.sanitizeList.bind(this)}
          />

          <UpdatePartnerConfig
            showUpdatePartnerConfigDialog={this.state.openUpdatePartnerConfigDialog}
            closeUpdatePartnerConfigDialog={() => { this.setState({ openUpdatePartnerConfigDialog: false }) }}
            partnerConfig={partnerConfig}
            showUpdatePartnerConfigProgressAlert={this.props.partnerStatusData.updatePartnerConfigLoader}
            showUpdatePartnerConfigSuccessAlert={this.props.partnerStatusData.updatePartnerConfigSuccess}
            showUpdatePartnerConfigErrorAlert={!!this.props.partnerStatusData.updatePartnerConfigError}
            updatePartnerConfigError={this.props.partnerStatusData.updatePartnerConfigError}
            updatePartnerConfig={this.updatePartnerConfig.bind(this)}

            resetUpdatePartnerConfigSuccessAlert={this.resetUpdatePartnerConfigSuccessAlert.bind(this)}
            resetUpdatePartnerConfigErrorAlert={() => { this.props.dispatch(actions.resetUpdatePartnerConfigError()) }}

            formatAndConvertToListString={this.sanitizeList.bind(this)}
            removeSquareBrackets={this.removeSquareBrackets.bind(this)}
            convertListToString={this.sanitizeList.bind(this)}
            convertStringToList={this.convertStringToList.bind(this)}
          />

          <UpdatePartnerConfigClaim
            showUpdatePartnerConfigClaimDialog={this.state.openUpdatePartnerConfigClaimDialog}
            closeUpdatePartnerConfigClaimDialog={() => { this.setState({ openUpdatePartnerConfigClaimDialog: false }) }}
            partnerConfigClaim={partnerConfigClaim}
            showUpdatePartnerConfigClaimProgressAlert={this.props.partnerStatusData.updatePartnerConfigClaimLoader}
            showUpdatePartnerConfigClaimSuccessAlert={this.props.partnerStatusData.updatePartnerConfigClaimSuccess}
            showUpdatePartnerConfigClaimErrorAlert={!!this.props.partnerStatusData.updatePartnerConfigClaimError}
            updatePartnerConfigClaimError={this.props.partnerStatusData.updatePartnerConfigClaimError}
            updatePartnerConfigClaim={this.updatePartnerConfigClaim.bind(this)}

            resetUpdatePartnerConfigClaimSuccessAlert={this.resetUpdatePartnerConfigClaimSuccessAlert.bind(this)}
            resetUpdatePartnerConfigClaimErrorAlert={() => { this.props.dispatch(actions.resetUpdatePartnerConfigClaiimError()) }}

            formatAndConvertToListString={this.sanitizeList.bind(this)}
            removeSquareBrackets={this.removeSquareBrackets.bind(this)}
            convertListToString={this.sanitizeList.bind(this)}
            convertStringToList={this.convertStringToList.bind(this)}

          />

          <UpdatePartnerConfigEmail
            showUpdatePartnerConfigEmailDialog={this.state.openUpdatePartnerConfigEmailDialog}
            closeUpdatePartnerConfigEmailDialog={() => { this.setState({ openUpdatePartnerConfigEmailDialog: false }) }}
            partner={partner}
            partnerConfigEmail={partnerConfigEmail}
            partnerConfigEmailClients={partnerConfigEmailClients}
            showUpdatePartnerConfigEmailProgressAlert={this.props.partnerStatusData.updatePartnerConfigEmailLoader}
            showUpdatePartnerConfigEmailSuccessAlert={this.props.partnerStatusData.updatePartnerConfigEmailSuccess}
            showUpdatePartnerConfigEmailErrorAlert={!!this.props.partnerStatusData.updatePartnerConfigEmailError}
            updatePartnerConfigEmailError={this.props.partnerStatusData.updatePartnerConfigEmailError}
            updatePartnerConfigEmail={this.updatePartnerConfigEmail.bind(this)}

            resetUpdatePartnerConfigEmailSuccessAlert={this.resetUpdatePartnerConfigEmailSuccessAlert.bind(this)}
            resetUpdatePartnerConfigEmailErrorAlert={() => { this.props.dispatch(actions.resetUpdatePartnerConfigEmailError()) }}

            formatAndConvertToListString={this.sanitizeList.bind(this)}
            removeSquareBrackets={this.removeSquareBrackets.bind(this)}
            convertListToString={this.sanitizeList.bind(this)}
            convertStringToList={this.convertStringToList.bind(this)}
          />

          <AddEditSmsChannel
            open={this.state.openAddSmsChannelDialog}
            existingChannel={this.state.editSmsChannel}
            onClose={() => {
              this.setState({ openAddSmsChannelDialog: false, editSmsChannel: null })
              this.props.dispatch(actions.resetTestSmsChannel())
            }}
            onSave={this.saveSmsChannel.bind(this)}
            saveLoading={this.props.partnerStatusData.saveSmsChannelLoader}
            saveSuccess={this.props.partnerStatusData.saveSmsChannelSuccess}
            saveError={this.props.partnerStatusData.saveSmsChannelError}
            onSaveSuccess={this.resetSaveSmsChannelSuccessAlert.bind(this)}
            onSaveErrorReset={() => {
              this.props.dispatch(actions.resetSaveSmsChannelError())
            }}
            onTest={this.testSmsChannel.bind(this)}
            onTestReset={() => { this.props.dispatch(actions.resetTestSmsChannel()) }}
            testLoading={this.props.partnerStatusData.testSmsChannelLoader}
            testResult={this.props.partnerStatusData.testSmsChannelResult}
            testError={this.props.partnerStatusData.testSmsChannelError}
          />

          <EditChannelResolution
            open={this.state.openChannelResolutionDialog}
            resolution={smsChannelResolution}
            channels={smsChannels}
            smsChannels={smsChannels}
            onClose={() => {
              this.setState({ openChannelResolutionDialog: false })
              this.props.dispatch(actions.resetSaveChannelResolutionError())
            }}
            onSave={this.saveChannelResolution.bind(this)}
            saveLoading={this.props.partnerStatusData.saveChannelResolutionLoader}
            saveSuccess={this.props.partnerStatusData.saveChannelResolutionSuccess}
            saveError={this.props.partnerStatusData.saveChannelResolutionError}
            onSaveSuccess={() => {
              this.props.dispatch(actions.resetSaveChannelResolutionSuccess())
            }}
            onSaveErrorReset={() => {
              this.props.dispatch(actions.resetSaveChannelResolutionError())
            }}
          />

          <TestSmsChannelDialog
            open={!!this.state.testSmsChannel}
            channels={smsChannels}
            defaultChannel={
              this.state.testSmsChannel
                ? this.state.testSmsChannel.channel_name || ''
                : ''
            }
            onClose={() => {
              this.setState({ testSmsChannel: null })
              this.props.dispatch(actions.resetTestSmsChannel())
            }}
            onTest={this.testSmsChannel.bind(this)}
            onReset={() => { this.props.dispatch(actions.resetTestSmsChannel()) }}
            testLoading={this.props.partnerStatusData.testSmsChannelLoader}
            testResult={this.props.partnerStatusData.testSmsChannelResult}
            testError={this.props.partnerStatusData.testSmsChannelError}
          />

          <AddEditPolicyMakerCheck
            open={this.state.openPolicyMakerCheckDialog}
            existingCheck={this.state.editPolicyMakerCheck}
            existingChecks={this.props.partnerStatusData.policyMakerChecks || []}
            onClose={() => {
              this.setState({ openPolicyMakerCheckDialog: false, editPolicyMakerCheck: null })
              this.props.dispatch(actions.resetSavePolicyMakerCheckError())
            }}
            onSave={this.savePolicyMakerCheck.bind(this)}
            saveLoading={this.props.partnerStatusData.savePolicyMakerCheckLoader}
            saveSuccess={this.props.partnerStatusData.savePolicyMakerCheckSuccess}
            saveError={this.props.partnerStatusData.savePolicyMakerCheckError}
            onSaveSuccess={this.resetSavePolicyMakerCheckSuccessAlert.bind(this)}
            onSaveErrorReset={() => {
              this.props.dispatch(actions.resetSavePolicyMakerCheckError())
            }}
          />

        </Container>
      </React.Fragment >
    );
  }
}

export default connect((state) => ({
  partnerStatusData: state.partnerStatus,
  globalData: state.global,
}))(PartnerStatus);
